// extracted by mini-css-extract-plugin
export var section = "Section-module--section--e6268";
export var styleGray = "Section-module--styleGray--aabde";
export var stylePurple = "Section-module--stylePurple--f3902";